import { render } from "./DocumentSearchMask.vue?vue&type=template&id=4e41d8f9&scoped=true&ts=true"
import script from "./DocumentSearchMask.vue?vue&type=script&lang=ts"
export * from "./DocumentSearchMask.vue?vue&type=script&lang=ts"

import "./DocumentSearchMask.vue?vue&type=style&index=0&id=4e41d8f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e41d8f9"]])

export default __exports__